<template>
  <div id="mobile_title">
    <div style="float: left" v-on:click="toggle_main_nav">
      <img id="mobile_title_nav_toggle" src="@/assets/nav.svg" width=15 height=15 />
    </div>

    <div style="float: right; text-align: right">
    <router-link to="/"><b>xrpintel</b></router-link>
    </div>

    <div style="clear: both"></div>
  </div>
</template>

<script>
export default {
  name: 'MobileTitle',

  methods : {
    toggle_main_nav : function(){
      this.$store.commit('toggle_nav', this.$mq);
    },
  }
}
</script>

<style scoped>
#mobile_title{
  background-color: #495aa2;
  color: white;
  padding: 5px;
  padding-left: 8px;
  padding-right: 15px;
}

#mobile_title_nav_toggle{
  cursor: pointer;
}

a, a:hover{
  color: white;
  text-decoration: none;
}
</style>
